import { render, staticRenderFns } from "./groupServer.vue?vue&type=template&id=0920921e&"
import script from "./groupServer.vue?vue&type=script&lang=js&"
export * from "./groupServer.vue?vue&type=script&lang=js&"
import style0 from "./groupServer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0920921e')) {
      api.createRecord('0920921e', component.options)
    } else {
      api.reload('0920921e', component.options)
    }
    module.hot.accept("./groupServer.vue?vue&type=template&id=0920921e&", function () {
      api.rerender('0920921e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/groupServer/groupServer.vue"
export default component.exports